import {html, css, LitElement} from 'lit';
import { add } from 'lodash';
import SlimSelect from 'slim-select'
import {repeat} from 'lit/directives/repeat.js';

export default class FilterSelect extends LitElement {
  
  static properties = {
    name: { type: String },
    value: { type: Array },
    options: { type: Array },
    searchText: { type: String },
    // opt-in "Select all / Deselect all" links above the options
    selectAll: { type: Boolean, attribute: 'select-all' },
  }

  // disable shadow dom to use global styles 
  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.name = this.getAttribute("name");
    this.value = JSON.parse(this.getAttribute("value")) || [];
    this.options = JSON.parse(this.getAttribute("options")) || [];
    this.searchText = '';
    this.selectAll = this.hasAttribute("select-all");

    document.addEventListener('filter-item:close', () => {
      this.searchText = '';
      this.requestUpdate();
    })
  }

  handleCheckboxChange(e) {
    // keep value in step with the boxes, or a re-render (searching the options, select all)
    // would put back what was ticked when the page loaded
    const value = String(e.target.value);
    const others = this.value.map(String).filter(v => v !== value);
    this.value = e.target.checked ? [...others, value] : others;

    // Dispatch a custom event that can be listened to from outside
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: {
        name: this.name,
        value: e.target.value,
        checked: e.target.checked
      },
      bubbles: true
    }));
  }

  // ticks or clears every option, then refreshes the search once rather than once per box
  async setAll(e, checked) {
    e.preventDefault();
    this.value = checked ? this.options.map(option => String(option.value)) : [];
    await this.updateComplete;
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: { name: this.name, value: this.value, checked },
      bubbles: true
    }));
  }

  handleSearch(e) {
    e.preventDefault();
    this.searchText = e.target.value;
    this.requestUpdate();
  }

  getFilteredOptions() {
    if (!this.searchText) return this.options;
    return this.options.filter(option => {
      const optionName = (option.name || option.text || option.label || '').toLowerCase();
      return optionName.includes(this.searchText.toLowerCase());
    });
  }

  render() {
    return html`
      <div class="search--filter-select__filter-select">
        ${this.options.length >= 10 ? html`
          <input 
            type="text" 
            class="search--filter-select__filter-select__search-input"
            placeholder="Search..."
            .value="${this.searchText}"
            @input="${this.handleSearch}"
          />
        ` : ''}

        <div class="search--filter-select__filter-select__options">
          ${repeat(
            this.getFilteredOptions(),
            (option) => option.value, // key function
            (option) => html`
              <label class="search--filter-select__filter-select__option">
                <span>${option && (option.name || option.text || option.label)}</span>
                <input type="checkbox" 
                  name="${this.name}[]" 
                  value="${option && option.value}"
                  .checked="${this.value.map(String).includes(String(option && option.value))}"
                  @change="${this.handleCheckboxChange}" />
              </label>
            `
          )}
        </div>

        ${this.selectAll ? html`
          <div class="search--filter-select__filter-select__bulk">
            <button type="button" @click="${(e) => this.setAll(e, true)}">Select all</button>
            <button type="button" @click="${(e) => this.setAll(e, false)}">Deselect all</button>
          </div>
        ` : ''}
      </div>
    `;
  }
}

customElements.define('filter-select', FilterSelect);